<div class="icon-card" [class.icon-card--white]="variant === 'white'" [class.icon-card--bordered]="bordered">
  <div class="icon-card__icon d-flex align-items-center justify-content-center" [ngClass]="{'icon-card__icon--pale-peach' : iconCreamBackgorund}">
    <img [src]="iconSrc" [width]="iconWidth ? iconWidth : 24" [height]="iconHeight ? iconHeight : 24" alt="" aria-hidden="true">
  </div>

  <h3 class="icon-card__title fs-5">{{ title }}</h3>
  <p *ngIf="value" class="icon-card__value fw-bold mb-2">{{ value }}</p>
  <p class="icon-card__description mb-0" [ngClass]="{'icon-card__description__black': blackDescription}">{{ description }}</p>
  <ng-container *ngIf="ctaText">
    <a *ngIf="isRouterLink; else externalCta" [routerLink]="ctaLink" class="icon-card__cta btn ui-btn ui-btn--secondary fw-bold">{{ ctaText }}</a>
    <ng-template #externalCta>
      <a [href]="ctaLink" class="icon-card__cta btn ui-btn ui-btn--secondary fw-bold">{{ ctaText }}</a>
    </ng-template>
  </ng-container>
</div>
